module.exports = __webpack_public_path__ + "static/img/banner_product_12.5a15677.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/产品服务/banner_product_12.png
// module id = 4r84
// module chunks = 0